import { useTranslation } from 'react-i18next';
import { TRACK } from '@/track/track.constants';
import { doTrack } from '@/track/track.service';
import { Modal } from '@seeqdev/qomponents';

interface GlobalScopeAccessConfirmModalProps {
  onCancel: () => void;
  onConfirm: () => void;
}

export const GlobalScopeAccessConfirmModal = ({ onCancel, onConfirm }: GlobalScopeAccessConfirmModalProps) => {
  const { t } = useTranslation();

  return (
    <Modal
      open={true}
      testId="globalScopeAccessConfirmModal"
      title={t('ITEM_ACL.GLOBAL_SCOPE_ACCESS.HEADER')}
      onClose={() => {
        doTrack(TRACK.ACCESS_CONTROL_GLOBAL_CONFIRMATION, 'cancel');
        onCancel();
      }}
      submitButtonLabel={t('ITEM_ACL.GLOBAL_SCOPE_ACCESS.CONFIRM')}
      onSubmit={() => {
        doTrack(TRACK.ACCESS_CONTROL_GLOBAL_CONFIRMATION, 'confirm');
        onConfirm();
      }}
      size="lg"
      cancelButtonLabel={t('CANCEL')}>
      <div>
        {t('ITEM_ACL.GLOBAL_SCOPE_ACCESS.MESSAGE')}
        <div className="sq-text-warning text-bolder tw:mt-sq-10" data-testid="globalScopeAccessWarning">
          {t('ITEM_ACL.GLOBAL_SCOPE_ACCESS.WARNING')}
        </div>
      </div>
    </Modal>
  );
};
